import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'ngc-verify-phone',
    templateUrl: './verify-phone.component.html',
    styleUrls: ['./verify-phone.component.scss']
})
export class VerifyPhoneComponent implements OnInit {

    @Input() phone: string;
    @Input() disableResendCodeBtnTimer: number;
    @Input() isSpinnerActive: boolean;
    @Input() formGroup: UntypedFormGroup;

    @Output() cancel = new EventEmitter<void>();
    @Output() sendCodeAgain = new EventEmitter<void>();
    @Output() verifyCode = new EventEmitter<void>();

    constructor() {
    }

    ngOnInit(): void {
    }

    onVerifyCode(): void {
        this.verifyCode.emit();
    }

    onSendCodeAgain() {
        this.sendCodeAgain.emit();
    }

    doCancel(): void {
        this.cancel.emit();
    }
}
